export default __webpack_public_path__ + "c986c1f04a250557e3a0d496d540b77e.svg";